import React, { Component } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import arrowkey from '../../../../src/content/images/icon/arrow-down.png';
import { UserIcon, MinusIcon, PlusIcon } from '~svg';
import './index.scss';
let TotalCount = 0,
  label = '',
  localizations = {};

class OptionList extends Component {
  constructor(props) {
    super(props);
    Object.keys(props.object).map((key) => {
      localizations[key] = props.intl.formatMessage({ id: `booking.${key}` });
    });
    this.labelTitle = this.props.intl.formatMessage({
      id: this.props.label,
    });
    this.state = {
      indexOfOption: 0,
      isFocused: this.props.isAlwaysOpen ? true : false,
      isHovered: this.props.isAlwaysOpen ? true : false,
      total: '',
    };
  }
  componentDidMount() {
    TotalCount = 0;
    label = '';

    Object.keys(this.props.object).map(this.calcTotal);
  }
  clearText = (event) => {
    document.querySelector(`#${event.target.id}`).value = '';
  };
  render() {
    let { tabIndex, label, isAlwaysOpen } = this.props;
    let { isFocused, indexOfOption, isHovered, total } = this.state;
    return (
      <div
        className="d-flex flex-column w-100  passengerMenu"
        onClick={() => {
          this.setState({ isFocused: !isFocused, isHovered: !isHovered });
        }}
        onMouseLeave={() => this.toggleSelect(null)}
      >
        <div
          className={`bookflight-item-passenger w-100 d-flex align-items-center justify-content-between cursor-pointer  bg-third-light border py-2 px-3 ${
            (this.state.isFocused || this.state.isHovered) &&
            'border-top-radius'
          }`}
        >
          <p
            className={`d-flex align-items-center m-0 eyebrow-note col-2 p-0 py-2 justify-content-center `}
          >
            <UserIcon size={16} color="#00798c" />
          </p>
          {!total && (
            <span className="px-2">
              <FormattedMessage id={label} />
            </span>
          )}
          <div className="col-9 px-0">
            <input
              style={{ textAlign: 'Start' }}
              type="text"
              className={`d-flex bookflight-typeahead-passenger col font-small text-truncate font-weight-bold text-captalize`}
              value={total}
              onBlur={() =>
                this.setState({
                  isFocused: isAlwaysOpen ? true : false,
                  isHovered: false,
                })
              }
              disabled
            />

            <input
              id="autoCompleteInput"
              onClick={() => {
                this.setState({ isFocused: !isFocused, isHovered: !isHovered });
              }}
              onKeyDown={(e) => {
                if (!isFocused && (e.keyCode === 13 || e.keyCode === 40))
                  this.setState({ isFocused: true });
                else if (isFocused && (e.keyCode === 13 || e.keyCode === 9))
                  this.setState({ isFocused: false, isHovered: false });
                else if (
                  isFocused === true &&
                  e.keyCode === 40 &&
                  indexOfOption < Object.keys(this.props.object).length - 1
                )
                  this.setState({
                    indexOfOption: this.state.indexOfOption + 1,
                  });
                else if (
                  isFocused === true &&
                  e.keyCode === 38 &&
                  indexOfOption > 0
                )
                  this.setState({
                    indexOfOption: this.state.indexOfOption - 1,
                  });
                else if (
                  isFocused === true &&
                  (e.keyCode === 107 || e.keyCode === 39)
                )
                  this.liOnClick(
                    'inc',
                    Object.keys(this.props.object)[indexOfOption],
                  );
                else if (
                  isFocused === true &&
                  (e.keyCode === 109 || e.keyCode === 37)
                )
                  this.liOnClick(
                    'dec',
                    Object.keys(this.props.object)[indexOfOption],
                  );
              }}
              type="text"
              className="d-flex bookflight-typeahead-passenger col font-small "
              style={{
                backgroundColor: 'transparent',
                textAlign: 'Start',
                color: 'white',
              }}
              value={this.props.value}
              onChange={(event) => this.clearText(event)}
              tabIndex={tabIndex}
            />
          </div>
          <div className="d-flex justify-content-center align-items-center  ">
            <img
              style={{ width: 10, height: 10 }}
              src={arrowkey}
              alt=""
              onClick={() => {
                this.setState({ isFocused: !isFocused, isHovered: !isHovered });
              }}
            />
          </div>
        </div>

        {this.renderList()}
      </div>
    );
  }

  renderList = () => {
    if (this.state.isFocused || this.state.isHovered)
      return (
        <div
          className="w-100 shadow bookflight-peoplepicker bg-third-light border border-top-0"
          style={{
            borderBottomLeftRadius: '1rem',
            borderBottomRightRadius: '1rem',
            borderColor: '#dee2e6',
            right: -1,
            top: 30,
          }}
        >
          <ul className="peoplepicker m-2">
            {Object.keys(this.props.object).map(this.renderObjctOptions)}
          </ul>
        </div>
      );
  };

  renderObjctOptions = (key, index) => {
    return (
      <li key={index}>
        <div
          className={`number-picker w-100 h-100
         
          `}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="picker-title m-0 position-static d-flex flex-row justify-content-between align-items-center font-small h-100">
            <span>
              <span>{localizations[key]}</span>
            </span>

            <ul className="number-picker-controls m-0 p-0 px-2 flex-start d-felx align-items-center ">
              <li
                className="d-flex align-items-center justify-content-center"
                onClick={() => {
                  this.liOnClick('dec', key);
                }}
              >
                <MinusIcon size={12} color="#00798c" />
              </li>
              <li className={`border-0  pl-2`}>
                <span className="text-primary font-large font-weight-bold">
                  {this.props.object[key]}
                </span>
              </li>
              <li
                className="d-flex align-items-center justify-content-center"
                onClick={() => {
                  this.liOnClick('inc', key);
                }}
              >
                <PlusIcon size={12} color="#00798c" />
              </li>
            </ul>
          </div>
        </div>
      </li>
    );
  };

  calcTotal = (key, index) => {
    let text = this.props.intl.formatMessage({
      id: `booking.${key.split('(')[0].toLowerCase().trim()}`,
    });

    if (this.props.object[key] !== 0) {
      TotalCount += this.props.object[key];
      label += `${this.props.object[key]} ${text}  `;
    }
    if (index === Object.keys(this.props.object).length - 1)
      this.setState({ total: label });
  };

  toggleSelect = (value) => {
    if (this.props.isAlwaysOpen) {
      this.setState({ isFocused: true, isHovered: true });
    } else {
      if (value) this.setState({ isFocused: true, isHovered: true });
      else if (!value) this.setState({ isFocused: false, isHovered: false });
      else this.setState({ isHovered: false });
    }
  };
  liOnClick = (value, key) => {
    this.props.onClick(value, key);
    TotalCount = 0;
    label = '';
    Object.keys(this.props.object).map(this.calcTotal);
  };
}
OptionList.propTypes = {
  intl: intlShape.isRequired,
};
export default injectIntl(OptionList);
